import { useState, useEffect, lazy, Suspense } from "react";
import "./styles/style.css";
import "./styles/responsive.css";
import { Layout } from "./webpage/layout";
import {
  userLoggedIn,
  userBeneFiciary,
  CartCountContext,
} from "./context/contextFile.jsx";
import TokenService from "./services/token.service";
import ScrollToTop from "./webpage/Component/scrollToTop";
import { Loader } from "./webpage/Component/loader.jsx";
import { Route, Routes } from "react-router-dom";
import { ROUTING } from "./utils/routes.js";
import { ToastContainer } from "react-toastify";
import { baseUrl } from "./services/baseUrl.js";
import FireBaseService from "./services/fireBase.js";
import { NotificationProvider } from "./context/NotificationContext.js";
import DeleteAccount from "./webpage/Registration/DeleteAccount.jsx";
import DeleteAccountConfirm from "./webpage/Registration/DeleteAccountConfirm.jsx";
import CartService from "./services/cart.service.js";

const VideoConference = lazy(
  () => import("./webpage/VideoConference/index.jsx"),
);
const HomePage = lazy(() => import("./webpage/homePage/homePage"));
const BookDoctor = lazy(() => import("./webpage/BookDoctor/bookDoctor"));
const BookLab = lazy(() => import("./webpage/BookLab/bookLab"));
const Insure = lazy(() => import("./webpage/Insurance/insure"));
const Pharmacy = lazy(() => import("./webpage/Pharmacy/pharmacy"));
const OurProducts = lazy(() => import("./webpage/Pharmacy/ourProducts"));
const BestSeller = lazy(() => import("./webpage/Pharmacy/bestSeller"));
const FrequentlyBought = lazy(
  () => import("./webpage/Pharmacy/frequentlyBought"),
);
const OurCategories = lazy(() => import("./webpage/Pharmacy/ourCategories"));
const Brands = lazy(() => import("./webpage/Pharmacy/brands"));
const ProductItem = lazy(() => import("./webpage/Pharmacy/ProductItem"));
const Cart = lazy(() => import("./webpage/Pharmacy/cart"));
const CheckOut = lazy(() => import("./webpage/Pharmacy/checkOut"));
const Login = lazy(() => import("./webpage/Registration/login"));
const Signup = lazy(() => import("./webpage/Registration/signup"));
const Contact = lazy(() => import("./webpage/ContactUs/contact"));
const Aboutus = lazy(() => import("./webpage/aboutUs/aboutus"));
const ProfileLayout = lazy(() => import("./webpage/profile/profileLayout"));
const Myprofile = lazy(
  () => import("./webpage/profile/profilePages/myprofile"),
);
const Beneficiary = lazy(
  () => import("./webpage/profile/profilePages/Beneficiary"),
);
const Reports = lazy(() => import("./webpage/profile/profilePages/reports"));
const MyInsurance = lazy(
  () => import("./webpage/profile/profilePages/insurance"),
);
const Billing = lazy(() => import("./webpage/profile/profilePages/billing"));
const Payment = lazy(() => import("./webpage/profile/profilePages/payment"));
const Logout = lazy(() => import("./webpage/profile/profilePages/logout"));
const Prescibtion = lazy(
  () => import("./webpage/profile/profilePages/prescibtion"),
);
const PrivacyPolicy = lazy(() => import("./webpage/Policies/privacyPolicy"));
const ShippingPolicy = lazy(() => import("./webpage/Policies/shippingPolicy"));
const ReturnPolicy = lazy(() => import("./webpage/Policies/returnPolicy"));
const Faqs = lazy(() => import("./webpage/Policies/faqs"));
const ChangePassword = lazy(
  () => import("./webpage/profile/profilePages/changePassword"),
);
const ForgetPassword = lazy(
  () => import("./webpage/Registration/forgetPassword"),
);
const DigitalRoshan = lazy(() => import("./webpage/Insurance/digitalRoshan"));
const OrderUser = lazy(
  () => import("./webpage/profile/profilePages/ordersUser"),
);
const InsureKaroLayout = lazy(
  () => import("./webpage/Insurance/insureKaroLayout"),
);
const SehatCard = lazy(() => import("./webpage/Insurance/sehatCard"));
const TermsOfUse = lazy(() => import("./webpage/Policies/termsOfUse"));
const LabBookingDetails = lazy(
  () => import("./webpage/profile/profilePages/labBookingDetails"),
);
const Page404 = lazy(() => import("./webpage/Component/page404"));
const Blogs = lazy(() => import("./webpage/Blogs/blogs"));
const DoctorBookingDetails = lazy(
  () => import("./webpage/profile/profilePages/doctorBookingDetails"),
);
const NewPassword = lazy(() => import("./webpage/Registration/newPassword"));
const PharmDetail = lazy(() => import("./webpage/Pharmacy/Pharm_Detail.jsx"));
const VerifyAccount = lazy(
  () => import("./webpage/Registration/VerifyAccount"),
);

function App() {
  const originalFetch = window.fetch;
  const { getCart } = CartService();
  const { getToken, rememberGet } = TokenService();
  const { requestFirebaseNotificationPermission } = FireBaseService();
  const [userToken, setUserToken] = useState();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [idFromBene, setIdFromBene] = useState("");
  const [vidToken, setVidToken] = useState(null);
  const [cartCount, setCartCount] = useState(0);

  const loggedFunc = (data) => {
    setIsUserLoggedIn(data);
  };

  useEffect(() => {
    if (rememberGet()) {
      setUserToken(getToken(rememberGet()));
    } else {
      setUserToken(getToken());
    }
    // eslint-disable-next-line
  }, []);

  const isForBeneficiary = (data) => {
    setIdFromBene(data);
  };

  useEffect(() => {
    if (userToken) {
      requestFirebaseNotificationPermission(userToken);
    }
    // eslint-disable-next-line
  }, [userToken]);

  useEffect(() => {
    if (vidToken) {
      window.fetch = async (...args) => {
        const [resource, config] = args;
        if (
          typeof resource === "string" &&
          resource.includes("https://api.videosdk.live/otel/v1/traces")
        ) {
          return new Response(null, { status: 204 });
        }
        if (
          typeof resource === "string" &&
          resource.includes("/infra/v1/meetings/init-config")
        ) {
          const newBody = JSON.stringify({
            ...JSON.parse(config?.body || "{}"),
            VideoToken: vidToken,
          });
          return originalFetch(`${baseUrl}/video/init-config`, {
            ...config,
            body: newBody,
            headers: {
              ...(config?.headers || {}),
              "Content-Type": "application/json",
            },
          });
        }
        return originalFetch(...args);
      };
      return () => {
        window.fetch = originalFetch;
      };
    }
    // eslint-disable-next-line
  }, [vidToken]);

  const getCartCountFunc = () => {
    if (userToken) {
      getCart()
        .then((e) => {
          if (e.data.success) setCartCount(e.data.data.length);
        })
        .catch((err) => {
          console.error("getCartFunc err", err);
        });
    }
  };

  useEffect(() => {
    getCartCountFunc();
  }, [userToken]);

  return (
    <div className="App">
      <ScrollToTop />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={1}
      />
      <NotificationProvider>
        <userLoggedIn.Provider value={isUserLoggedIn}>
          <userBeneFiciary.Provider value={idFromBene}>
            <CartCountContext.Provider value={cartCount}>
              <Suspense fallback={<Loader />}>
                <Routes>
                  <Route element={<Layout cartCount={cartCount} />}>
                    <Route path={ROUTING.HOMEPAGE} element={<HomePage />} />
                    <Route
                      path={ROUTING.BOOK_DOCTOR}
                      element={<BookDoctor />}
                    />
                    <Route path={ROUTING.BOOK_LAB} element={<BookLab />} />
                    <Route
                      path={ROUTING.INSURE_KARO}
                      element={<InsureKaroLayout />}
                    >
                      <Route
                        path={ROUTING.INSURANCE}
                        element={
                          <Insure
                            isForBeneficiary={isForBeneficiary}
                            idFromBene={idFromBene}
                          />
                        }
                      />
                      <Route
                        path={ROUTING.DIGITAL_ROSHAN}
                        element={<DigitalRoshan />}
                      />
                      <Route
                        path={ROUTING.SEHAT_CARD}
                        element={<SehatCard />}
                      />
                    </Route>
                    <Route
                      path={ROUTING.PHARMACY}
                      element={<Pharmacy isForBeneficiary={isForBeneficiary} />}
                    >
                      {/* <Route path={ROUTING.BUYINGFOR} element={<BuyingFor  />} /> */}
                      <Route
                        path={ROUTING.OURPRODUCTS}
                        element={<OurProducts />}
                      />
                      <Route
                        path={ROUTING.BESTSELLER}
                        element={<BestSeller />}
                      />
                      <Route
                        path={ROUTING.FREQUENTLY_BOUGHT}
                        element={<FrequentlyBought />}
                      />
                      <Route
                        path={`${ROUTING.OUR_CATEGORIES}/:catId?`}
                        element={<OurCategories />}
                      />
                      <Route
                        path={`${ROUTING.BRANDS}/:brandId?`}
                        element={<Brands />}
                      />
                      <Route
                        path={`${ROUTING.PRODUCT_ITEM}/:productItemId`}
                        element={<ProductItem func={getCartCountFunc} />}
                      />
                      <Route
                        path={ROUTING.CART}
                        element={<Cart func={getCartCountFunc} />}
                      />
                      {userToken && (
                        <Route
                          path={ROUTING.CHECKOUT}
                          element={<CheckOut idFromBene={idFromBene} />}
                        />
                      )}
                    </Route>
                    <Route
                      key="contact"
                      path={ROUTING.CONTACT}
                      element={<Contact />}
                    />
                    <Route path={ROUTING.ABOUTUS} element={<Aboutus />} />
                    {userToken && (
                      <>
                        <Route
                          path={ROUTING.PROFILE}
                          element={<ProfileLayout />}
                        >
                          <Route
                            path={ROUTING.MYPROFILE}
                            element={<Myprofile />}
                          />
                          <Route
                            path={ROUTING.BENEFICIARY}
                            element={<Beneficiary />}
                          />
                          <Route
                            path={`${ROUTING.BENEFICIARY}/:beneficiaryId`}
                            element={<Beneficiary />}
                          />
                          <Route
                            path={ROUTING.PRESCIPTION}
                            element={<Prescibtion />}
                          />
                          <Route path={ROUTING.REPORT} element={<Reports />} />
                          <Route
                            path={ROUTING.ORDERS}
                            element={<OrderUser />}
                          />
                          <Route
                            path={ROUTING.MY_INSURANCE}
                            element={<MyInsurance />}
                          />
                          <Route path={ROUTING.BILLING} element={<Billing />} />
                          <Route path={ROUTING.PAYMENT} element={<Payment />} />
                          <Route path={ROUTING.LOGOUT} element={<Logout />} />
                        </Route>
                        <Route
                          path={`${ROUTING.LAB_BOOKING}/:BookingId`}
                          element={<LabBookingDetails />}
                        />
                        <Route
                          path={`${ROUTING.DOCTOR_BOOKING}/:DoctorBookingId`}
                          element={<DoctorBookingDetails />}
                        />
                        <Route
                          path={`${ROUTING.Pharm_Detail}/:id`}
                          element={<PharmDetail />}
                        />
                      </>
                    )}

                    <Route
                      path={ROUTING.LOGIN}
                      element={<Login isLogin={loggedFunc} />}
                    />
                    <Route path={ROUTING.BLOGS} element={<Blogs />} />
                    <Route path={ROUTING.SIGNUP} element={<Signup />} />
                    <Route
                      path={ROUTING.VERIFY_ACCOUNT}
                      element={<VerifyAccount />}
                    />
                    <Route
                      path={ROUTING.PRIVACY_POLICY}
                      element={<PrivacyPolicy />}
                    />
                    <Route
                      path={ROUTING.SHIPPING_POLICY}
                      element={<ShippingPolicy />}
                    />
                    <Route
                      path={ROUTING.RETURN_POLICY}
                      element={<ReturnPolicy />}
                    />
                    <Route
                      path={ROUTING.TERMS_OF_USE}
                      element={<TermsOfUse />}
                    />
                    <Route path={ROUTING.FAQS} element={<Faqs />} />
                    <Route
                      path={ROUTING.PASSWORD}
                      element={<ChangePassword />}
                    />
                    <Route
                      path={ROUTING.FORGET_PASSWORD}
                      element={<ForgetPassword />}
                    />
                    <Route
                      path={ROUTING.DELETE_ACCOUNT}
                      element={<DeleteAccount />}
                    />
                    <Route
                      path={ROUTING.CONFIRM_DELETE_ACCOUNT}
                      element={<DeleteAccountConfirm />}
                    />
                    <Route
                      path={ROUTING.CHANGE_PASSWORD}
                      element={<NewPassword />}
                    />
                    <Route
                      path={`${ROUTING.VIDEO_CONFERENCE}/:videoId`}
                      element={<VideoConference setVidToken={setVidToken} />}
                    />
                    <Route path="/*" element={<Page404 />} />
                  </Route>
                </Routes>
              </Suspense>
            </CartCountContext.Provider>
          </userBeneFiciary.Provider>
        </userLoggedIn.Provider>
      </NotificationProvider>
    </div>
  );
}

export default App;
